__turbopack_context__.v({
  "className": "vazirmatn_ae9e761a-module__s287ga__className",
});
